<template>
  <div class="data-examine" ref="body">
    <div class="option-box">
      <div class="btn1" @click="handleAllRelieve">全部解除</div>
      <div class="btn2" @click="handleAllRemove">全部删除</div>
    </div>
    <div class="search-box" ref="search">
      <el-form
        inline
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item>
          <el-select style="width: 140px" class="form-select" clearable popper-class="form-select-dropdown" :popper-append-to-body="false" v-model="formInline.status" placeholder="状态">
            <el-option
              v-for="item in warningStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 140px" clearable class="form-select" popper-class="form-select-dropdown" :popper-append-to-body="false" v-model="formInline.town" placeholder="所属乡镇">
            <el-option
              v-for="item in townshipList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 180px" class="form-select" clearable popper-class="form-select-dropdown" :popper-append-to-body="false" v-model="formInline.gridId" placeholder="区域负责人">
            <el-option
              v-for="item in userList"
              :key="item.gridId"
              :label="item.name"
              :value="item.gridId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            clearable
            class="form-time-select"
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate"
            popper-class="form-time-select-dropdown form-time-picker-dropdown"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="form-submit-btn" @click="handleSearch">查询</div>
        </el-form-item>
      </el-form>
    </div>
    <TableBox class="table-box">
      <Table :height="tableHeight" :table-data="tableData" @openInfo="openInfo" @selectionChange="selectionChange" @openRelieve="openRelieve" @openRemove="openRemove"></Table>
    </TableBox>
    <div style="text-align: center;padding-top: 10px" ref="page">
      <el-pagination
        class="ai-pagination"
        popper-class="ai-pagination"
        @current-change="handleCurrentChange"
        :current-page="formInline.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formInline.limit"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <Dialog :show-foot="false" :title="'数据详情-' + filterStatus(earlyWarningInfo.status)" :background-image="require('../../../assets/dp/device-box.png')"
            v-if="showEarlyWarning" width="95%" @close="showEarlyWarning = false" @confirm="showEarlyWarning = false">
      <early-warning :info="earlyWarningInfo"></early-warning>
    </Dialog>
    <Confirm :tip="tipList[optionType]" v-show="showConfirm" @close="showConfirm = false" @confirm="handleConfirm">
      <div v-if="optionType === 2" class="reason-box">
        <el-radio-group v-model="relieveReason" class="form-radio-group">
          <el-radio label="各类反光">各类反光</el-radio>
          <el-radio label="各类烟筒">各类烟筒</el-radio>
          <el-radio label="太阳或者车灯">太阳或者车灯</el-radio>
          <el-radio label="无法辨别">无法辨别</el-radio>
          <el-radio label="非火光等热源">非火光等热源</el-radio>
          <el-radio label="真火延时处理">真火延时处理</el-radio>
          <el-radio label="其他">其他</el-radio>
        </el-radio-group></div>
    </Confirm>
  </div>
</template>

<script>
import TableBox from '@/components/ClipBox/index.vue'
import Table from "./components/Table";
import {getWarningList, removeBatch, rescindBatch} from "../../../api/warning";
import Dialog from "@/components/Dialog/index"
import earlyWarning from "./components/earlyWarning";
import {getLiveAddress} from "../../../api/device";
import {getGridList} from "../../../api/set";
import { filterStatus } from "../../../utils/filterStatus";
import { townshipList } from "../../../utils/common";
import Confirm from "../../../components/Dialog/Confirm";
import { warningProcess } from "@/api/warning";
export default {
  name: "index", // 数据审核
  components: { TableBox, Table, Dialog, earlyWarning, Confirm },
  data () {
    return {
      date: [],
      tipList: ['确认全部解除？', '确认全部删除？', '确认解除？', '确认删除？'],
      tableHeight: 500,
      optionType: 0, // 0全部解除， 1全部删除
      showConfirm: false,
      townshipList,
      relieveReason: '各类反光',
      warningStatus: [
        { label: '研判', value: 0 },
        { label: '签收中', value: 1 },
        { label: '处置中', value: 2 },
        { label: '审核中', value: 3 }
      ],
      total: 0,
      formInline: {
        status: '',
        gridId: '',
        fromDate: '',
        toDate: '',
        page: 1,
        limit: 10
      },
      tableData: [],
      earlyWarningInfo: {},
      showEarlyWarning: false,
      userList: [],
      selectList: [],
      info: {},
      adminInfo: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getTableHeight()
    })
    this.adminInfo = this.$store.state.user.userInfo
    window.addEventListener("resize", () => {
      this.$nextTick(() => {
        this.getTableHeight()
      })
    })
    this.$bus.on('refreshWarning', () => {
      this.getList()
    })
    this.getList()
    this.getGridList()
  },
  destroyed() {
    this.$bus.off('refreshWarning')
  },
  methods: {
    getTableHeight () {
      this.tableHeight = this.$refs.body.clientHeight - this.$refs.search.clientHeight - this.$refs.page.clientHeight - 15
    },
    filterStatus,
    handleSearch () {
      this.formInline.page = 1
      this.$bus.emit('refreshWarning')
    },
    changeDate (date) {
      if (date === null) {
        this.formInline.fromDate = ''
        this.formInline.toDate = ''
      } else {
        this.formInline.fromDate = date[0]
        this.formInline.toDate = date[1]
      }
    },
    handleCurrentChange (val) {
      this.formInline.page = val
      this.getList()
    },
    getList () {
      getWarningList(this.formInline).then(res => {
        this.tableData = res.data.list
        console.log(this.tableData)
        this.total = res.data.totalCount
      })
    },
    openInfo (item) {
      getLiveAddress({deviceSerials: [item.deviceSerial]}).then(res => {
        if (res.data.daHuaYunRui.length > 0) {
          const device = {
            streams: res.data.daHuaYunRui[0].streams,
            deviceId: res.data.daHuaYunRui[0].deviceId,
            deviceName: res.data.daHuaYunRui[0].deviceName,
            deviceLocation: res.data.daHuaYunRui[0].deviceLocation
          }
          this.earlyWarningInfo = item
          this.earlyWarningInfo.device = device
          this.showEarlyWarning = true
        } else if (res.data.haiKangYS7.length > 0) {
          const device = {
            url: res.data.haiKangYS7[0].url,
            token: res.data.haiKangYS7Token,
            deviceSerial: res.data.haiKangYS7[0].deviceSerial,
            deviceName: res.data.haiKangYS7[0].deviceName,
            deviceLocation: res.data.haiKangYS7[0].deviceLocation
          }
          this.earlyWarningInfo = item
          this.earlyWarningInfo.device = device
          this.showEarlyWarning = true
        } else {
          this.$message.warning('该设备已被移除或不在线！')
        }
      })
    },
    getGridList () {
      getGridList({page: 1, pageSize: 999}).then(res => {
        this.userList = res.data
      })
    },
    handleAllRelieve () {
      if (this.selectList.filter(x => x.status === 0).length > 0) {
        this.optionType = 0
        this.showConfirm = true
      } else {
        this.$message.warning('当前未选择研判状态报警！')
      }
    },
    handleAllRemove () {
      if (this.selectList.length > 0) {
        this.optionType = 1
        this.showConfirm = true
      } else {
        this.$message.warning('当前未选择报警！')
      }
    },
    selectionChange (e) {
      this.selectList = e
    },
    openRelieve (row) {
      this.info = row
      this.optionType = 2
      this.showConfirm = true
    },
    openRemove (row) {
      this.info = row
      this.optionType = 3
      this.showConfirm = true
    },
    handleConfirm () {
      let form = []
      switch (this.optionType) {
        case 0: // 全部解除
          this.selectList.filter(x => x.status === 0).forEach(item => {
            form.push(item.warningNum)
          })
          rescindBatch(form).then(res => {
            this.$message.success(res.msg)
            this.handleSearch()
            this.showConfirm = false
          })
          break;
        case 1: // 全部删除
          this.selectList.forEach(item => {
            form.push(item.warningNum)
          })
          removeBatch(form).then(res => {
            this.$message.success(res.msg)
            this.handleSearch()
            this.showConfirm = false
          })
          break;
        case 2: // 单个解除
          warningProcess({
            id: this.info.id,
            status: 5,
            adminId: this.info.adminId || this.adminInfo.user_id,
            relieveReason: this.relieveReason
          }).then(res => {
            this.$message.success(res.msg)
            this.handleSearch()
            this.showConfirm = false
          })
          break;
        case 3: // 单个删除
          form = [this.info.warningNum]
          removeBatch(form).then(res => {
            this.$message.success(res.msg)
            this.handleSearch()
            this.showConfirm = false
          })
          break;
      }
    }
  }
}
</script>

<style scoped lang="less">
.data-examine{
  width: 100%;
  height: 100%;
  position: relative;
  /deep/.reason-box{
    padding: 0 50px 20px 50px;
  }
  .option-box{
    position: absolute;
    display: flex;
    top: -62px;
    right: 0;
    .btn1{
      width: 126px;
      height: 52px;
      background: url("~@/assets/img/settings/button-bg2.png") no-repeat
        center / 100% 100%;
      font-size: 18px;
      text-align: center;
      line-height: 52px;
      font-weight: 400;
      color: #00B2FF;
      cursor: pointer;
    }
    .btn2{
      width: 126px;
      height: 52px;
      background: url("~@/assets/img/settings/button-bg3.png") no-repeat
        center / 100% 100%;
      font-size: 18px;
      text-align: center;
      line-height: 52px;
      font-weight: 400;
      color: #FF1C2F;
      cursor: pointer;
    }
  }
  .search-box {
    padding-top: 28px;
    .form-input {
      width: 200px;
      height: 40px;
    }
    .form-select{
      /deep/ .el-input__inner{
        height: 40px;
      }
    }

    &::v-deep {
      .el-form-item__label {
        padding-right: 28px;
        font-size: 20px;
        color: #ffffff;
      }
    }
    .form-submit-btn {
      width: 150px;
      height: 50px;
      line-height: 50px;
      margin-top: -5px;
      margin-left: 25px;
      font-size: 17px;
      color: #00b2ff;
      letter-spacing: 12px;
      text-indent: 12px;
      text-align: center;
      background: url("~@/assets/img/settings/button-bg2.png") no-repeat
        center / 100% 100%;
      cursor: pointer;
    }
  }
  .table-box{
    width: 100%;
    height: calc(100% - 150px);
  }
}
/deep/ .el-input__inner {
  width: 100%;
  //height: 40px;
  font-size: 18px;
  line-height: inherit;
  font-weight: 500;
  background: rgba(0, 45, 65, 0.2);
  border: 1px solid #00B2FF;
  color: #00B2FF;
  box-shadow: 0 0 12px 4px rgba(0, 178, 255, 0.2) inset;

  &::-webkit-input-placeholder {
    color: rgba(0, 178, 255, 0.3);
  }
}
/deep/ .el-form-item__label{
  color: #FFFFFF;
  font-size: 18px;
}
/deep/ .el-table, /deep/.el-table__expanded-cell {
  background-color: rgba(255, 255, 255, 0) !important;
}
/deep/.el-table--border::after, /deep/.el-table--group::after, /deep/.el-table::before{
  display: none;
}
</style>
